if (!customElements.get('cuf-bulk-summary')) {
 customElements.define('cuf-bulk-summary', class extends HTMLElement {
  connectedCallback() {
   this.info=this.closest('product-info');this.form=document.getElementById(this.dataset.form);
   if(!this.info || !this.form)return;
   this.data=JSON.parse(this.querySelector('script').textContent);
   this.money=new Intl.NumberFormat('en-GB',{style:'currency',currency:this.dataset.currency});
   this.refresh=()=>this.update();
   this.info.addEventListener('input',this.refresh);this.info.addEventListener('change',this.refresh);
   this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{if(String(data.sectionId)===this.dataset.section)this.update();});
   this.unsubscribeQuantity=subscribe(PUB_SUB_EVENTS.quantityUpdate,this.refresh);
   this.update();
  }
  disconnectedCallback(){this.info?.removeEventListener('input',this.refresh);this.info?.removeEventListener('change',this.refresh);this.unsubscribe?.();this.unsubscribeQuantity?.();}
  update(){
   const variant=this.data.variants.find(v=>String(v.id)===this.form.querySelector('[name="id"]').value);
   const input=this.info.querySelector('[name="quantity"]');
   const qty=input?Number(input.value):1,count=Number(this.dataset.count);
   const valid=variant && Number.isInteger(qty) && qty>0 && (!input || input.validity.valid);
   const label=this.info.querySelector('.quantity__label');
   const labelText=label && [...label.childNodes].find(node=>node.nodeType===3 && node.textContent.trim());
   if(labelText)labelText.textContent=this.data.labels.packs+' ';
   this.querySelector('[data-bulk-count]').textContent=valid?this.data.labels.count.replace('__packs__',qty).replace('__chairs__',qty*count):'—';
   this.querySelector('[data-bulk-total]').textContent=valid?this.money.format(variant.price*qty/100):'—';
   this.querySelector('[data-bulk-unit]').textContent=variant?this.money.format(variant.price/100/count):'—';
   const saving=this.querySelector('[data-bulk-saving]');
   if(saving){
    const small=variant && this.data.smallVariants?.find(v=>v.title.replace(/ - 10 Chairs$/,'')===variant.title && v.available);
    const rate=this.data.deliveryRates?.find(r=>qty*count<=r[0]);
    const savingValue=valid && small && rate?small.price*(qty*count/10)-(variant.price*qty+rate[1]):0;
    saving.hidden=!(this.dataset.currency==='GBP' && savingValue>0);
    saving.textContent=saving.hidden?'':'Estimated UK delivered saving: '+this.money.format(savingValue/100)+' vs '+(qty*count/10)+' smaller 10-chair packs. Bulk delivery used in this comparison: '+this.money.format(rate[1]/100)+'.';
   }
  }
 });
}
